import { render } from "./BuyukSehirLogoSvg.vue?vue&type=template&id=c6d252f4"
import script from "./BuyukSehirLogoSvg.vue?vue&type=script&lang=js"
export * from "./BuyukSehirLogoSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__